<template>
  <div
    v-if="allContracts.length > 0"
    class="card-tabs mb-m"
  >
    <el-row
      class="mb-l"
      type="flex"
      align="middle"
      justify="space-between"
    >
      <div style="display: flex; align-items: center;">
        <el-menu
          :default-active="activeIndex"
          class="approved-documents mb-m"
          mode="horizontal"
          menu-trigger="click"
          @select="handleSelectContract"
        >
          <el-submenu index="1">
            <template slot="title">Luồng phê duyệt</template>
            <el-menu-item
              v-for="c in allContracts"
              :key="c.id"
              :index="c.id"
            >
              {{ c.name }}
            </el-menu-item>
          </el-submenu>
        </el-menu>
        <span class="approve-title">{{ activeLabel }}</span>
      </div>
      <el-button
        type="primary"
        size="large"
        @click="() => workflowVisible = true"
      >
        Sơ đồ quy trình
      </el-button>
    </el-row>
    <el-tabs
      v-if="!!contract"
      :value="contractTypeStatus"
      @tab-click="handleClick"
    >
      <el-tab-pane
        :label="`Chưa có trạng thái (${counts.none || 0})`"
        :name="'none'"
      />
      <el-tab-pane
        v-for="(tab, index) in tabs"
        :key="index"
        :label="`${tab.name} (${counts[tab.key] || 0})`"
        :name="tab.key"
      />
    </el-tabs>
    <ContractWorkflow
      :key="`${contract.id}_${contractTypeStatus}`"
      :visible="workflowVisible"
      :contract="contract"
      :contract-type-status="contractTypeStatus"
      @close="() => workflowVisible = false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import documentUtilServices from "@/services/document-util";
import ContractWorkflow from "../popups/ContractWorkflow.vue";

export default {
  name: "CardTabs",
  components: {
    ContractWorkflow
  },
  props: {
    config: Object,
    contract: Object,
    contractTypeStatus: String,
    objectType: Object,
    moduleField: Object,
    contractModules: Array,
  },
  data() {
    return {
      counts: {},
      workflowVisible: false
    };
  },
  computed: {
    ...mapGetters("contract", ["allContracts", "allContractStatus", "allContractSteps"]),
    activeIndex() {
      const routeQuery = this.$route.query
      if (routeQuery && routeQuery.contract_type) {
        return this.allContracts.find((item) => item.contract_type === routeQuery.contract_type).id
      }
      return this.allContracts[0].id || ""
    },
    activeLabel() {
      const routeQuery = this.$route.query
      if (routeQuery && routeQuery.contract_type) {
        return this.allContracts.find((item) => item.contract_type === routeQuery.contract_type).name
      }
      return this.allContracts[0].name || ""
    },
    contractSteps() {
      const result = this.allContractSteps.filter((s) => s.contract_id === this.contract.id)
      return result.sort((a, b) => a.order - b.order)
    },
    tabs() {
      const contractActionStatuses = this.contractSteps.map((s) => s.actions.map((a) => a.extra_data.to_state)).flat();
      const result = [
        ...(contractActionStatuses || []).map((status) => ({
          name: this.allContractStatus.find((s) => s.value === status)?.name,
          key: status
        }))
      ]
      return result;
    },
    currentCountPayload() {
      if (this.contractModules.length > 0 && this.moduleField) {
        return [
          {
            document_key: this.objectType.role_action,
            filters: {
              type: this.config.extra.key,
              [`extra.${this.moduleField.key}`]: { $in: this.contractModules.map((m) => m.key) },
              [`contract_status.${this.contract?.contract_type}`]: null
            },
            query_id: 'none'
          },
          ...this.tabs.map((tab) => {
            return {
              document_key: this.objectType.role_action,
              filters: {
                type: this.config.extra.key,
                [`extra.${this.moduleField.key}`]: { $in: this.contractModules.map((m) => m.key) },
                [`contract_status.${this.contract?.contract_type}`]: tab.key
              },
              query_id: tab.key
            }
          })
        ]
      }
      return [
        {
          document_key: this.objectType.role_action,
          filters: {
            type: this.config.extra.key,
            [`contract_status.${this.contract?.contract_type}`]: null
          },
          query_id: 'none'
        },
        ...this.tabs.map((tab) => {
          return {
            document_key: this.objectType.role_action,
            filters: {
              type: this.config.extra.key,
              [`contract_status.${this.contract?.contract_type}`]: tab.key
            },
            query_id: tab.key
          }
        })
      ]
    },
  },
  watch: {
    currentCountPayload: "getObjectCountData",
  },
  mounted() {
    this.getObjectCountData();
  },
  methods: {
    handleClick(tab) {
      this.$emit('change', tab.name)
    },
    handleSelectContract(key, keyTab) {
      const contract = this.allContracts.find((item) => item.id === key)
      this.$router.push({ name: this.$route.name, params: this.$route.params, query: { contract_type: contract.contract_type }})
    },
    async getObjectCountData() {
      if (this.currentCountPayload.length > 0) {
        documentUtilServices.post_count({
          items: this.currentCountPayload,
        }).then((res) => {
          const counts = {}
          this.currentCountPayload.forEach(p => {
            counts[p.query_id] = res.counts[`${p.document_key}_${p.query_id}`]
          });
          this.counts = counts
        })
      }
    },
  },
};
</script>

<style lang="scss">
.approve-title {
  font-size: 24px;
  font-weight: 600;
  color: rgb(48, 65, 86);
}
.approved-documents {
  border: none !important;
  margin-bottom: 0 !important;
  margin-right: 8px;
  .el-submenu__title {
    font-weight: 500;
    font-size: 16px !important;
    text-transform: uppercase;
    color: #000000 !important;
    border: 1px solid #828282;
    border-radius: 8px;
    border-bottom: 1px solid #828282 !important;
  }
}
</style>
